import React from 'react';
import ReactQuill from 'react-quill-new';

import { useUiField } from '../hooks';
import { UiField } from './UiField';

const modules = {
  toolbar: [
    ['bold', 'italic', 'underline', 'link'],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' },
    ],
    ['clean'],
  ],
};

export function UiQuill(props) {
  const [uiFieldProps, inputProps] = useUiField(props, { isTextarea: true });

  // There is sometimes an issue here where the initial render of the ReactQuill causes React Final Form to mark the field as dirty
  // useSemanticHTML={false} emits editor.root.innerHTML like react-quill 2 did.
  // The default getSemanticHTML() escapes every space as &nbsp;, which blocks
  // word-wrap anywhere the stored HTML is rendered raw (e.g. ComplianceDetailLog).
  return (
    <UiField {...uiFieldProps}>
      <ReactQuill
        theme="snow"
        {...inputProps}
        modules={modules}
        useSemanticHTML={false}
      />
    </UiField>
  );
}
